import { render, staticRenderFns } from "./FinancialIcon.vue?vue&type=template&id=68976c38"
import script from "./FinancialIcon.vue?vue&type=script&lang=js"
export * from "./FinancialIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports